module.exports = __webpack_public_path__ + "img/ico_associate_user.405ce425.svg";